<template>
    <div class="logindDalog">
        <el-dialog  :visible.sync="dialogTableVisible" width="800px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="content">
                <div class="title">
                    <div class="text">添加作者信息</div>
                    <img class="tanx" src="../../../../../viewsGangAn/components/images/tanx.png" alt="" @click="closeDialog()">
                </div>
                <div class="main">
                    <div class="list">
                        <div class="lable"><span>*</span>作者真实姓名：</div>
                        <div class="input">
							<el-input  placeholder="3-20个字符，包括大小写字母、数字、下划线、不允许有空格！"  v-model="input"> </el-input>
						</div>
                    </div>
                    <div class="list">
                        <div class="lable"><span>*</span>署名情况：</div>
                        <div class="input">
							<el-input  placeholder="请选择署名情况为：本命、别名或匿名"  v-model="input"> </el-input>
						</div>
                    </div>
                    <div class="list">
                        <div class="lable"><span>*</span>作者信息：</div>
                        <div class="switch">
                            <el-switch
                                v-model="value22"
                                active-color="#2196F3"
                                inactive-color="#ffffff">
                            </el-switch>
							<div class="t">联系到作者</div>
						</div>
                    </div>
                    <div class="list">
                        <div class="lable"><span>*</span>用户类型：</div>
                        <div class="input">
							<Select v-model="buttonType" placeholder="请选择用户所属类型" filterable clearable>
                                <Option>涛涛他</Option>
                            </Select>
						</div>
                    </div>
                    <div class="list">
                        <div class="lable"><span>*</span>证件类型：</div>
                        <div class="input">
							<Select v-model="buttonType" placeholder="请选择证件所属类型" filterable clearable>
                                <Option>涛涛他</Option>
                            </Select>
						</div>
                    </div>
                    <div class="list">
                        <div class="lable"><span>*</span>证件号：</div>
                        <div class="input">
							<el-input  placeholder="请输入有效证件号"  v-model="input"> </el-input>
						</div>
                    </div>
                    <div class="list">
						<div class="lable"><span>*</span>上传合同：</div>
						<div class="upData">
							<el-upload
                                class="avatar-uploader"
                                action="https://jsonplaceholder.typicode.com/posts/"
                                :show-file-list="false"
                                >
                                <!-- <img v-if="enterpriseImg" :src="enterpriseImg" class="avatar"> -->
                                <img class="addUp" src="../images/add.png" alt="">
                                <div class="textMsg">若选择身份证，请上传身份证正反面扫描文件，正反面在扫描件同一面显示，10M以内</div>
                            </el-upload>
						</div>
					</div>
                </div>
                <div class="btnBox">
					<div class="cxybz" @click="confirm()">确认</div>
				</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "logindDalog",
        props: {
            dataObj: {
                type: Object,
                default: function () {
                    return {
                        title: '添加作者信息',
                        content: '弹框提示',
                        dalogType: 1
                    }
                },
            },
        },
        components: {
        },
        data() {
            return {
                dialogTableVisible: false,
                input: '',
                value22: '',
                buttonType: ''
            }
        },
        computed: {
        },
        watch: {
            $route(to, from) {
            }
        },
        mounted() {
        },
        methods: {
            closeDialog() {
                this.dialogTableVisible = !this.dialogTableVisible
            },
            confirm() {
                this.$emit('confirm',this.dataObj)
            }
        },
        beforeDestroy() {}
    };
</script>

<style lang="less" scoped>
.content{
    background: #fff;
    .title{
        display: flex;
        align-items: center;
        height: 66px;
        border-bottom: solid 1px #E5E5E5;
        padding: 0 26px;
        .text{
            font-size: 16px;
            font-weight: 700;
            color: #333;
        }
        .tanx{
            width: 14px;
            height: 14px;
            margin-left: auto;
            cursor: pointer;
        }
    }
    .main{
        padding: 35px 44px;
        height: 500px;
        overflow-y: scroll;
        .list{
            display: flex;
            margin-bottom: 16px;
            .lable{
                font-size: 14px;
                line-height: 40px;
                flex: 0 0 110px;
                text-align: right;
                span{
                    color: #E70000;
                }
            }
            .input{
                flex: 1;
                margin-left: 10px;
                line-height: 40px;
                /deep/ .ivu-input{
                    height: 40px;
                }
                /deep/ .ivu-date-picker{
                    width: 100%;
                }
                /deep/ .ivu-input-suffix i{
                    line-height: 40px;
                }
                /deep/ .el-textarea__inner{
                    min-height: 186px !important;
                }
                /deep/ .ivu-select{
                    width: 198px;
                }
                /deep/ .ivu-date-picker-rel{
                    width: 198px;
                }
                .elinput2{
                    width: 306px;
                    /deep/ .ivu-date-picker-rel{
                        width: 306px;
                    }
                }
                /deep/ .ivu-select-single{
                    .ivu-select-selection{
                        height: 40px;
                    }
                    .ivu-select-placeholder{
                        height: 40px;
                        line-height: 40px;
                    }
                    .ivu-select-selected-value{
                        height: 40px;
                        line-height: 40px;
                    }
                }
                /deep/ .ivu-select-input{
                    height: 40px;
                    line-height: 40px;
                    padding-top: 0;
                    padding-bottom: 0;
                }
            }
            .switch{
                flex: 1;
                margin-left: 10px;
                line-height: 40px;
                display: flex;
                align-items: center;
                font-size: 14px;
                .t{
                    margin-left: 8px;
                }
            }
            .upData{
                border: solid 1px #E5E5E5;
                border-radius: 4px;
                flex: 1;
                padding: 17px 32px;
                .addUp{
                    width: 76px;
                    height: 76px;
                    margin: auto;
                }
                /deep/.el-upload{
                    display: block;
                }
                .textMsg{
                    font-size: 14px;
                    margin-top: 10px;
                    color: #BDBDBD;
                    text-align: center;
                }
            }
        }
    }
    .btnBox{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 50px;
        padding-top: 30px;
        .cz{
            font-size: 14px;
            color: #999999;
            text-align: center;
            width: 170px;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            border: 1px solid #E5E5E5;
            margin: 0 10px;
            text-align: center;
            cursor: pointer;
        }
        .cxybz{
            width: 170px;
            height: 40px;
            background: #2196F3;
            line-height: 40px;
            border-radius: 4px;
            margin: 0 10px;
            color: #fff;
            text-align: center;
            cursor: pointer;
        }
	}
}
.logindDalog{
    /deep/ .el-dialog{
        border-radius: 16px;
        overflow: hidden;
        position: absolute;
        margin: auto !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    /deep/ .el-dialog__body{
        padding: 0;
    }
    /deep/ .el-dialog__header{
        padding: 0;
    }
}
</style>
